function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import ImageNotFound from "../../images/image-not.jpg";
const useStyles = makeStyles(() => ({
  spinner: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto auto"
  },
  error: {
    pointerEvents: "none"
  }
}));

function FallBackImage({
  src,
  fallBackSrc,
  className,
  fallBackStyles,
  ...props
}) {
  const styles = useStyles();
  const [loaded, setLoaded] = React.useState(false);
  const [error, setError] = React.useState(false);
  const imageSrc = !error ? src : fallBackSrc;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", _extends({
    src: imageSrc,
    onLoad: () => setLoaded(true),
    className: clsx(className, error && styles.error, error && fallBackStyles),
    onError: () => {
      setError(true);
      setLoaded(true);
    },
    alt: ""
  }, props)), !loaded && !error && /*#__PURE__*/React.createElement(CircularProgress, {
    color: "primary",
    size: 40,
    classes: {
      root: styles.spinner
    }
  }));
}

FallBackImage.defaultProps = {
  fallBackSrc: ImageNotFound
};
export default FallBackImage;